import { useLogout } from "@/utils/logout";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export type CloseProps = {};

export const Close: React.FC<CloseProps> = ({}) => {
  const location = useLocation();

  const logout = useLogout(`route:${location.pathname}`);
  const initiated = useRef(false);

  useEffect(() => {
    if (initiated.current) return;
    initiated.current = true;
    logout();
  }, [logout]);
  return null;
};
